import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { LanternUtilsModule } from "@lantern/app/common/utils";
import { LanternCoreUtilsModule } from "@lantern/app/core/utils/utils.module";

import { ButtonGroupComponent } from "./button-group.component";
import { ButtonOptionComponent } from "./button.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LanternUtilsModule,
    LanternCoreUtilsModule
  ],
  declarations: [ButtonOptionComponent, ButtonGroupComponent],
  exports: [ButtonOptionComponent, ButtonGroupComponent]
})
export class ButtonGroupModule {}
